export default {
  title: {
    id: 'reassurance_items_title',
    defaultMessage: 'Your perks with every purchase',
  },
  warranty: {
    id: 'reassurance_items_warranty',
    defaultMessage: '1-year seller warranty',
  },
  shipping: {
    id: 'reassurance_items_shipping',
    defaultMessage: 'Free standard shipping',
  },
  return: {
    id: 'reassurance_items_return',
    defaultMessage: 'Free {days}-day returns',
  },
  service: {
    id: 'reassurance_items_customer_service',
    defaultMessage: 'Friendly customer service',
  },
}
